import * as React from "react";
import { observer } from "mobx-react";
import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Campaign = CampaignRecommendationsWithOffersQuery.Campaigns;
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { UitkLink } from "uitk-react-link";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { InfoDialog } from "../InfoDialog/InfoDialog";
import { useLocalization } from "@shared-ui/localization-context";

export interface CampaignHeaderProps {
  campaign: Campaign;
  campaignIndex: number;
  openDialog: (dialogPath: string) => void;
  closeDialog: () => void;
  campaignTitle?: string;
  campaignCopyAlignment?: string;
}

// header of the campaigns with title, subtitle and terms and conditions
export const CampaignHeader = observer(
  ({ campaign, campaignIndex, openDialog, closeDialog, campaignTitle, campaignCopyAlignment }: CampaignHeaderProps) => {
    const { formatText } = useLocalization();
    const isHavingOriginCity = campaign.fromOriginHeaderText;
    const defaultHeadingConfig: UitkHeadingProps = { level: 2, size: 700 };
    const centeredHeadingConfig: UitkHeadingProps = { level: 2, size: 800 };
    const campaignHeading = campaignTitle ? campaignTitle : campaign.headline;
    const isCentered = campaignCopyAlignment === "centered";
    const headingConfig = isCentered ? centeredHeadingConfig : defaultHeadingConfig;

    return (
      <div
        className={
          isCentered
            ? "center-campaignCopyAlignment all-t-padding-three all-l-padding-three"
            : "CampaignHeader all-l-padding-three"
        }
        data-testid="campaign-header"
      >
        <UitkHeading {...headingConfig}>{campaignHeading}</UitkHeading>
        <div className={isCentered ? "all-t-padding-one" : ""}>
          {campaign.description.short && (
            <span
              className={
                isCentered ? "all-r-margin-one uitk-type-paragraph-400" : "all-r-margin-one uitk-type-paragraph-300"
              }
            >
              {campaign.description.short}
            </span>
          )}
          {isHavingOriginCity && (
            <span className={isCentered ? "uitk-type-paragraph-400" : "all-r-margin-one uitk-type-paragraph-300"}>
              {`${campaign.fromOriginHeaderText}.`}
            </span>
          )}
          {campaign.termsAndConditions && (
            <>
              <UitkLink
                className={isCentered ? "center_termsAndConditions" : "terms-conditions-text"}
                inline={isCentered ? false : true}
                onClick={openDialog.bind(this, `terms-conditions-${campaignIndex}`)}
              >
                <button>{formatText("merchCampaign.termsConditions.label")}</button>
              </UitkLink>
              <QueryRoute query={{ pwaDialog: `terms-conditions-${campaignIndex}` }}>
                <Layer id={`terms-conditions-dialog-${campaignIndex}`}>
                  <InfoDialog
                    infoText={campaign.termsAndConditions}
                    closeDialog={closeDialog}
                    buttonText={formatText("DestinationsByAffinity.priceDialogCloseButton")}
                  />
                </Layer>
              </QueryRoute>
            </>
          )}
        </div>
      </div>
    );
  }
);
